import { observer } from 'mobx-react'
import { Link } from 'react-router-dom'
import Heading from '@/ui/Heading'

interface DriveIntegrationExplanationsProps {
  provider: 'google_drive' | 'onedrive' | 'dropbox' | 'azure_blob_storage'
}

const DriveIntegrationExplanations = observer(
  ({ provider }: DriveIntegrationExplanationsProps) => {
    return (
      <>
        {provider === 'azure_blob_storage' && (
          <div className="knowledge-page-info">
            <Heading
              variant="system"
              title="Gestión manual"
              subtitle="La gestión manual te permite sincronizar tus documentos fácilmente sin tener que integrar AiKit con ningún proveedor de almacenamiento externo."
              size="large"
            />
            <div className="knowledge-page-info-container">
              <div className="knowledge-page-info-box">
                <Heading
                  variant="system"
                  title="Proceso de integración"
                  size="large"
                />
                <ol>
                  <li>
                    Accede a la sección de{' '}
                    <Link to="/knowledge-bases">bases de conocimiento</Link>.
                  </li>
                  <li>Sube los documentos que deseas sincronizar.</li>
                </ol>
              </div>
              <div className="knowledge-page-info-box">
                <Heading
                  variant="system"
                  title="Información importante"
                  size="large"
                />
                <ul>
                  <li>
                    La sincronización puede tardar hasta una hora en tomar
                    efecto.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}

        {provider === 'google_drive' && (
          <div className="knowledge-page-info">
            <Heading
              variant="system"
              title="Integración con Google Drive"
              subtitle="La integración con Google Drive te permite sincronizar automáticamente tus documentos con AiKit de forma sencilla."
              size="large"
            />
            <div className="knowledge-page-info-container">
              <div className="knowledge-page-info-box">
                <Heading
                  variant="system"
                  title="Proceso de integración"
                  size="large"
                />
                <ol>
                  <li>
                    Selecciona la cuenta de Google Drive que deseas conectar con
                    AiKit.
                  </li>
                  <li>
                    Una vez vinculada tu cuenta, encontrarás una nueva carpeta
                    llamada "AiKit" en la raíz de tu Google Drive.
                  </li>
                  <li>
                    Todos los documentos que coloques en la carpeta "AiKit" se
                    sincronizarán automáticamente con nuestra plataforma.
                  </li>
                </ol>
              </div>
              <div className="knowledge-page-info-box">
                <Heading
                  variant="system"
                  title="Información importante"
                  size="large"
                />
                <ul>
                  <li>
                    La sincronización se realiza automáticamente cada hora.
                  </li>
                  <li>
                    Todos los documentos dentro de la carpeta AiKit serán
                    procesados.
                  </li>
                  <li>
                    Puedes organizar tus documentos en subcarpetas dentro de la
                    carpeta AiKit.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}

        {provider === 'onedrive' && (
          <div className="knowledge-page-info">
            <Heading
              variant="system"
              title="Integración con One Drive"
              subtitle="La integración con One Drive te permite sincronizar automáticamente tus documentos con AiKit de forma sencilla."
              size="large"
            />

            <div className="knowledge-page-info-container">
              <div className="knowledge-page-info-box">
                <Heading
                  variant="system"
                  title="Proceso de integración"
                  size="large"
                />
                <ol>
                  <li>
                    Selecciona la cuenta de One Drive que deseas conectar con
                    AiKit.
                  </li>
                  <li>
                    Una vez vinculada tu cuenta, encontrarás una nueva carpeta
                    llamada "Apps/AiKit" en la raíz de tu Google Drive.
                  </li>
                  <li>
                    Todos los documentos que coloques en la carpeta "Apps/AiKit"
                    se sincronizarán automáticamente con nuestra plataforma.
                  </li>
                </ol>
              </div>
              <div className="knowledge-page-info-box">
                <Heading
                  variant="system"
                  title="Información importante"
                  size="large"
                />
                <ul>
                  <li>
                    La sincronización se realiza automáticamente cada hora.
                  </li>
                  <li>
                    Todos los documentos dentro de la carpeta AiKit serán
                    procesados.
                  </li>
                  <li>
                    Puedes organizar tus documentos en subcarpetas dentro de la
                    carpeta AiKit.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}

        {provider === 'dropbox' && (
          <div className="knowledge-page-info">
            <Heading
              variant="system"
              title="Integración con Dropbox"
              subtitle="La integración con Dropbox te permite sincronizar automáticamente tus documentos con AiKit de forma sencilla."
              size="large"
            />
            <div className="knowledge-page-info-container">
              <div className="knowledge-page-info-box">
                <Heading
                  variant="system"
                  title="Proceso de integración"
                  size="large"
                />
                <ol>
                  <li>
                    Selecciona la cuenta de Dropbox que deseas conectar con
                    AiKit.
                  </li>
                  <li>
                    Una vez vinculada tu cuenta, encontrarás una nueva carpeta
                    llamada "Apps/AiKit" en la raíz de tu Dropbox.
                  </li>
                  <li>
                    Todos los documentos que coloques en la carpeta "Apps/AiKit"
                    se sincronizarán automáticamente con nuestra plataforma.
                  </li>
                </ol>
              </div>
              <div className="knowledge-page-info-box">
                <Heading
                  variant="system"
                  title="Información importante"
                  size="large"
                />
                <ul>
                  <li>
                    La sincronización se realiza automáticamente cada hora.
                  </li>
                  <li>
                    Todos los documentos dentro de la carpeta AiKit serán
                    procesados.
                  </li>
                  <li>
                    Puedes organizar tus documentos en subcarpetas dentro de la
                    carpeta AiKit.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )}
      </>
    )
  },
)

export default DriveIntegrationExplanations
